import axios from 'axios';

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8001/api/',
    headers: {
        'Content-Type': 'application/json',
    },
});

// アップロード画像の参照先。
// 本番はS3（REACT_APP_STORAGE_URLでバケットの公開URLを指定）、
// 未設定時（ローカル開発）はAPIオリジン配下の /storage を使う。
// いずれの場合も末尾は「/」なしで統一し、呼び出し側は `${storageBaseUrl}/${path}` の形で組み立てる。
export const storageBaseUrl = (
    process.env.REACT_APP_STORAGE_URL
    || `${api.defaults.baseURL.replace(/\/api\/?$/, '')}/storage`
).replace(/\/+$/, '');

// リクエスト時にトークン付与 & trailing slash 除去
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('access_token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        // Laravel はトレイリングスラッシュ不要なので除去
        if (config.url) {
            config.url = config.url.replace(/\/+$/, '');
        }
        // FormData を送る場合は Content-Type を削除して axios/ブラウザに自動設定させる
        // （手動で 'multipart/form-data' を設定すると boundary が欠落してサーバーがパースできない）
        if (config.data instanceof FormData) {
            delete config.headers['Content-Type'];
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// レスポンス時のエラーハンドリング
api.interceptors.response.use(
    (response) => {
        return response;
    },
    async (error) => {
        // アクセストークンが無効な場合の処理
        if (error.response && error.response.status === 401 && !window.location.pathname.startsWith('/customer/login')) {
            localStorage.removeItem('access_token');
            localStorage.removeItem('refresh_token');
            localStorage.removeItem('customer_id');
            window.location.href = '/customer/login';
        }
        return Promise.reject(error);
    }
);

export default api;